import type { HouseModeConfig, InitiativeSettings, Persona, Voice } from '../../types/settings';

export const defaultPersona: Persona = { tone: 'warm', address: 'je', verbosity: 0.3, humor: false, proactiveGreeting: true };

export const voices: Voice[] = [
  { id: 'anna-mls', name: 'Anna', engine: 'Piper · nl_NL-mls', where: 'lokaal', note: 'Rustig, helder. Standaard.', pitch: 1, rate: 1.02 },
  { id: 'femke', name: 'Femke', engine: 'Piper · nl_NL-femke', where: 'lokaal', note: 'Iets warmer en lager.', pitch: 0.9, rate: 0.96 },
  { id: 'ronnie', name: 'Ronnie', engine: 'Piper · nl_BE-ronnie', where: 'lokaal', note: 'Vlaamse tongval, zacht.', pitch: 0.8, rate: 1 },
  { id: 'neural', name: 'Neural', engine: 'Cloudstem', where: 'cloud', note: 'Natuurlijkst, maar kost per zin.', pitch: 1.05, rate: 1.04 },
];

export const defaultHouseModes: HouseModeConfig[] = [
  { mode: 'Vrij', sound: 'aan', notifications: 'alle', initiative: 'normaal', wall: 'vol', trigger: 'Standaard overdag' },
  { mode: 'Focus', sound: 'uit', notifications: 'alleen veiligheid', initiative: 'laag', wall: 'gedimd', trigger: 'Focusblok in agenda' },
  { mode: 'Samen', sound: 'zacht', notifications: 'belangrijk', initiative: 'laag', wall: 'gedimd', trigger: 'Twee stemmen in de woonkamer' },
  { mode: 'Slapen', sound: 'uit', notifications: 'alleen veiligheid', initiative: 'uit', wall: 'klok', trigger: '“Welterusten” of 23:30' },
  { mode: 'Afwezig', sound: 'uit', notifications: 'belangrijk', initiative: 'normaal', wall: 'klok', trigger: 'Niemand thuis > 20 min' },
];

export const defaultInitiative: InitiativeSettings = {
  threshold: 0.7,
  perHour: 3,
  quietFrom: '22:30',
  quietTo: '07:00',
  channels: { wand: true, bureau: true, telefoon: true, stem: false },
};

/** Recent candidates with their initiative score, to preview the threshold */
export const initiativeSamples = [
  { action: 'Koffiezetapparaat aan bij opstaan', score: 0.83 },
  { action: 'Slack-samenvatting in dagoverzicht', score: 0.8 },
  { action: 'Slaapkamer voorverwarmen', score: 0.74 },
  { action: 'Focusblok voorstellen', score: 0.66 },
  { action: 'Melden dat het gaat regenen', score: 0.58 },
  { action: 'Vragen of je wilt sporten', score: 0.41 },
];
